import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card, CardBody, CardHeader, CardTitle } from 'reactstrap'
import { appendOnboarding } from '../../../../../features/session/sessionSlice'
import { appendModel } from '../../../../../features/site/siteSlice'
import { serviceMap } from '../../../../utils/common'

function SummaryCard({ showEditButtons }){
    const dispatch = useDispatch()

    const model = useSelector(state => state.site.model)
    const state = useSelector(state => state.session.onboarding)

    const { siteForm } = model

    return <Card
        className="my-2"
        style={{
            maxWidth: "50em",
            border: "1px solid #ccc"
        }}>
        <CardHeader>
            Social Media Summary
        </CardHeader>
        <CardBody>
            
            <CardTitle tag="h4" className={showEditButtons ? "d-flex justify-content-between align-items-center" : ""}>
                <div>
                    <img src={serviceMap.gmb.img} class="mr-2 rounded img-thumbnail" style={{width:"40px"}} />
                    {serviceMap.gmb.titleUnformatted}
                </div>
                {showEditButtons && <button className="ml-3 btn btn-outline-info btn-sm" onClick={() => {
                    dispatch(appendModel({
                        siteForm: {
                            ...siteForm,
                            attr: {
                                ...siteForm.attr,
                                accounts: {
                                    ...(siteForm?.attr?.accounts ?? {}),
                                    gmb: undefined
                                }
                            }
                        }
                    }))
                    dispatch(appendOnboarding({
                        step: 2,
                        socialMediaService: "gmb"
                    }))
                }}>Edit</button>}
            </CardTitle>
            <h4>
                <small class="text-muted">Account:</small> {state.dontHaveIt.gmb ? "N/A" : siteForm?.attr?.accounts?.gmb?.accountName}
            </h4>
            <h4>
                <small className="text-muted">Location:</small> {state.dontHaveIt.gmb ? "N/A" : siteForm?.attr?.accounts?.gmb?.locationName}
            </h4>
            
            <CardTitle tag="h4" className={`${showEditButtons ? "d-flex justify-content-between align-items-center" : ""} mt-4`}>
                <div>
                    <img src={serviceMap.fbPage.img} class="mr-2 rounded img-thumbnail" style={{width:"40px"}} />
                    {serviceMap.fbPage.titleUnformatted}
                </div>
                {showEditButtons && <button className="ml-3 btn btn-outline-info btn-sm" onClick={() => {
                    dispatch(appendModel({
                        siteForm: {
                            ...siteForm,
                            attr: {
                                ...siteForm.attr,
                                accounts: {
                                    ...(siteForm?.attr?.accounts ?? {}),
                                    fbPage: undefined
                                }
                            }
                        }
                    }))
                    dispatch(appendOnboarding({
                        step: 2,
                        socialMediaService: "fbPage"
                    }))
                }}>Edit</button>}
            </CardTitle>
            <h4>
                <small class="text-muted">Account Page:</small> {state.dontHaveIt.fbPage ? "N/A" : siteForm.attr?.accounts?.fbPage?.pageName}
            </h4>
            {siteForm.attr?.accounts?.fbPage?.igPageId && <h4>
                <small class="text-muted">Instagram Page Id:</small> {siteForm.attr?.accounts?.fbPage?.igPageId}
            </h4>}
            
            <CardTitle tag="h4" className={`${showEditButtons ? "d-flex justify-content-between align-items-center" : ""} mt-4`}>
                <div>
                    <img src={serviceMap.linkedinOrg.img} class="mr-2 rounded img-thumbnail" style={{width:"40px"}} />
                    {serviceMap.linkedinOrg.titleUnformatted}
                </div>
                {showEditButtons && <button className="ml-3 btn btn-outline-info btn-sm" onClick={() => {
                    dispatch(appendModel({
                        siteForm: {
                            ...siteForm,
                            attr: {
                                ...siteForm.attr,
                                accounts: {
                                    ...(siteForm?.attr?.accounts ?? {}),
                                    linkedinOrg: undefined
                                }
                            }
                        }
                    }))
                    dispatch(appendOnboarding({
                        step: 2,
                        socialMediaService: "linkedinOrg"
                    }))
                }}>Edit</button>}
            </CardTitle>
            <h4>
                <small class="text-muted">Organization:</small> {state.dontHaveIt.linkedinOrg ? "N/A" : siteForm?.attr?.accounts?.linkedinOrg?.organizationName}
            </h4>
        </CardBody>
    </Card>
}

SummaryCard.defaultProps = {
    showEditButtons: false
}

export default SummaryCard